// 小程序微商详
export default {
  routes: [
    {
      path: '/micro-detail-app',
      name: 'microDetailApp',
      meta: {
        pageId: 'C9986',
        level: 2
      },
      component: () =>
        import(/* webpackChunkName: "microDetailApp" */ '../views/microDetailApp/index.vue')
    },
    {
      path: '/prerender/micro-detail-app',
      name: 'pre-render-microDetailApp',
      meta: {
        desc: '预渲染微商详'
      },
      component: async () => await import('../views/microDetailApp/index-prerender.vue')
    },
    {
      path: '/micro-detail',
      name: 'microDetail',
      meta: {
        pageId: 'H9155',
        level: 2
      },
      component: () =>
        import(/* webpackChunkName: "microDetail" */ '../views/microDetail/index.vue')
    }
  ]
}
